import { Container } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Datagrid, List, TextField, TextInput, useListController, useTranslate } from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { hasPermissionFunction } from 'src/helper/HasPermission'

export const ExtAirAirlineList = (props) => {
  const translate = useTranslate()
  const { setSort, isFetching } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
      if (isSorting && isFetching) {
        setIsLoading(true)
      } else if (isLoading && isSorting && !isFetching) {
        setIsLoading(false)
        setIsSorting(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const airlineFilters = [
    <TextInput label={translate('ra.field.id')} source='id' defaultValue='' />,
    <TextInput label={translate('ra.field.short_name')} source='short_name__ilike' defaultValue='' />,
    <TextInput label={translate('ra.field.long_name')} source='long_name__ilike' defaultValue='' />,
  ]

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.ext-air-airline')}>
        <List
          {...props}
          resource='ext-air-airline'
          component='div'
          filters={airlineFilters}
          actions={<ListViewTopToolbar exporterDisable /* hasCreate={hasPermissionFunction('ext-air-airline', 'create')} */ />}
        >
          <Datagrid rowClick='show' setSort={onClickSort} isLoading={isLoading}>
            <TextField source='id' label={translate('ra.field.id')} />
            <TextField source='short_name' label={translate('ra.field.short_name')} />
            <TextField source='long_name' label={translate('ra.field.long_name')} />
              <ListViewActionsButtons label={translate('ra.action.actions')} fieldsName={['short_name']} genderElement='masculine' disableRevision/>
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}